import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { useInputValue } from '../../hooks/useInputValue'
import Switch from 'react-switch'
import Select from 'react-select'

import './styles.scss'
export const PodForm = ({
  item,
  isLoading,
  virtualMachineList,
  virtualMachineListToEdit,
  onSubmit,
  cancelLink,
}) => {
  const [podsSelected, setPodsSelected] = useState([])
  const [checked, setChecked] = useState(item !== null ? (item.status ? true : false) : false)
  const [podsModified, setPodsModified] = useState(false)

  const { ...name } = useInputValue(
    {
      value: item ? item.name : '',
      name: 'name',
      type: 'text',
      required: true,
      disabled: isLoading,
    },
    false
  )

  const { ...virtualmachine } = useInputValue(
    {
      value: item ? item.name : '',
      name: 'virtualmachine',
      disabled: isLoading,
    },
    false
  )

  const { ...description } = useInputValue(
    {
      value: item ? item.description : '',
      name: 'description',
      disabled: isLoading,
    },
    false
  )

  const sw = () => {
    const handleChange = (nextChecked) => {
      setChecked(nextChecked)
    }
    return (
      <div className="swcomponent">
        <Switch onChange={handleChange} checked={checked} className="react-switch" />
      </div>
    )
  }

  const handleCourseChange = (selectedOptions) => {
    setPodsSelected(selectedOptions)
    setPodsModified(true)
  }

  const hadleSubmit = (e) => {
    e.preventDefault()

    let virtualMachines = []

    if (podsModified) {
      virtualMachines = podsSelected.length > 0
        ? podsSelected.map(vselec => vselec.value)
        : []
    } else {
      virtualMachines = virtualMachineListToEdit.map(course => course.value)
    }

    const data = {
      name: name.value,
      virtualmachines: virtualMachines,
      description: description.value,
      status: checked,
    }

    onSubmit(data)
  }

  return (
    <div className="form-container">
      <form disabled={isLoading} onSubmit={hadleSubmit}>

        <div className="form-group">
          <label htmlFor="name-input">Nombre Pod {name.required ? '*' : ''}</label>
          <InputText id="name-input" {...name} />
        </div>

        <div className="form-group">
          <label htmlFor="name-input">Descripción Pod {description.required ? '*' : ''}</label>
          <InputText id="name-input" {...description} />
        </div>

        <div className="form-group">
          <label htmlFor="type-input">Recurso remoto {virtualmachine.required ? '*' : ''}</label>

          <Select
            defaultValue={virtualMachineListToEdit}
            isMulti
            name="virtualmachine"
            options={virtualMachineList}
            className="basic-multi-select"
            id="virtualmachine"
            classNamePrefix="select"
            onChange={handleCourseChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="estado-input">Estado </label>
          {sw()}
        </div>

        <div className="button-group">
          <Button
            label={isLoading ? 'Guardando...' : 'Guardar'}
            disabled={isLoading}
            type="submit"
            className="button primary"
          />
          <Link to={cancelLink} className="button secondary">
            Cancelar
          </Link>
        </div>

      </form>
    </div>

  )
}

PodForm.propTypes = {
  item: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  cancelLink: PropTypes.string.isRequired,
}
